import styled from 'styled-components';

export const Container = styled.main`
  background: #fff;
  display: flex;
  height: calc(100% - 56px);

  @media (min-width: 600px) {
    height: calc(100% - 64px);
  }
`;

export const DividerVertical = styled.div`
  display: none;
  width: 0px;
  height: 100%;
  border: 1px solid rgba(124, 141, 181, 0.25);

  @media (min-width: 768px) {
    display: flex;
  }
`;
